module.exports = __webpack_public_path__ + "static/media/a1.b8ca932.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zhengxiaoyue/a1.mp3
// module id = WJID
// module chunks = 0